export const signOut = () => (dispatch) => {
  dispatch({ type: "SIGN_OUT_USER" });
  dispatch({ type: "RESET" });
  dispatch({ type: "SET_SELECTED_DATE", date: new Date() });
};
